import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Modal,
  Row,
  Col,
  Badge,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
  FiFileText,
  FiSearch,
  FiPrinter,
  FiDownload,
  FiFile,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logoImage from "../assets/mboxLogo.jpeg";

const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;
const cookies = new Cookies();

const Factura = () => {
  const id_Usuario = cookies.get("id_Usuario");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [informacionSarList, setInformacionSarList] = useState([]);
  const [ordenesPaquetesList, setOrdenesPaquetesList] = useState([]);
  const [rtnsList, setRtnsList] = useState([]);
  const [showRtnModal, setShowRtnModal] = useState(false);
  const [rtnSearchTerm, setRtnSearchTerm] = useState("");
  const [rtnFacturaInfo, setRtnFacturaInfo] = useState(null);
  const [selectedPrefacturaLabel, setSelectedPrefacturaLabel] = useState("");
  const [total, setTotal] = useState(0);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    idInformacionSar: "",
    idOrdenesPaquetes: "",
    correlativo: "",
    tipoCliente: "Consumidor Final",
    nombreCliente: "",
    rtnCliente: "",
    metodoPago: "Efectivo",
    comprobantePago: "",
    fechaEmision: new Date().toLocaleDateString("en-CA", {
      timeZone: "America/Tegucigalpa",
    }),
    estado: "Activa",
    idUsuario: id_Usuario,
  });

  const [editingId, setEditingId] = useState(null);

  const itemsPerPageOptions = [5, 10, 20, 50];
  const metodosPago = ["Efectivo", "Tarjeta", "Transferencia", "Otros"];
  const tiposCliente = ["Consumidor Final", "Otro"];

  useEffect(() => {
    fetchData();
    fetchInformacionSar();
    fetchRtns();
    fetchOrdenesPaquetes();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  const handlePrefacturaChange = (e) => {
    const inputValue = e.target.value;
    setSelectedPrefacturaLabel(inputValue);

    const selectedOption = ordenesPaquetesList.find(
      (orden) =>
        `Orden #${orden.numeroOrden} - ${
          orden.cliente?.nombre || "Sin cliente"
        } (Total: L. ${orden.total?.toFixed(2) || "0.00"})` === inputValue
    );


    if (selectedOption) {
      setFormData((prev) => ({
        ...prev,
        idOrdenesPaquetes: selectedOption.idOrdenesPaquetes,
      }));
      setTotal(selectedOption.total || 0); 
    } else {
      setFormData((prev) => ({
        ...prev,
        idOrdenesPaquetes: "",
      }));
    }
  };

  useEffect(() => {
    if (formData.idOrdenesPaquetes) {
      const selectedOrden = ordenesPaquetesList.find(
        (orden) => orden.idOrdenesPaquetes === formData.idOrdenesPaquetes
      );

      if (selectedOrden) {
        setSelectedPrefacturaLabel(
          `Orden #${selectedOrden.numeroOrden} - ${
            selectedOrden.cliente?.nombre || "Sin cliente"
          } (Total: L. ${selectedOrden.total?.toFixed(2) || "0.00"})`
        );
      }
    }
  }, [formData.idOrdenesPaquetes, ordenesPaquetesList]);
  const fetchData = async () => {
    const bearertoken = cookies.get("token");
    try {
      const [facturasResponse, ordenesResponse] = await Promise.all([
        fetch(`${API_HOST}/facturas`, {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }),
        fetch(`${API_HOST}/ordenes`, {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }),
      ]);

      const facturas = await facturasResponse.json();
      const ordenes = await ordenesResponse.json();

      const facturasConTotales = facturas.map((factura) => {
        if (!factura.ordenPaquete) return factura;

        const ordenesRelacionadas = ordenes.filter(
          (o) => o.numeroOrden === factura.ordenPaquete.numeroOrden
        );
        const subtotal = ordenesRelacionadas.reduce(
          (sum, o) => sum + parseFloat(o.subtotal || 0),
          0
        );
        const descuento = ordenesRelacionadas.reduce(
          (sum, o) => sum + parseFloat(o.descuento || 0),
          0
        );
        const isv = ordenesRelacionadas.reduce(
          (sum, o) => sum + parseFloat(o.isv || 0),
          0
        );
        const total = ordenesRelacionadas.reduce(
          (sum, o) => sum + parseFloat(o.total || 0),
          0
        );

        return {
          ...factura,
          ordenPaquete: {
            ...factura.ordenPaquete,
            subtotal,
            descuento,
            totalISV: isv,
            total,
          },
        };
      });
   
      const facturasOrdenadas = facturasConTotales.sort(
        (a, b) => b.idFactura - a.idFactura
      );

      setData(facturasOrdenadas);
      setFilteredData(facturasOrdenadas);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "No se pudieron cargar las facturas", "error");
    }
  };

  const fetchOrdenesPaquetes = async () => {
    const bearertoken = cookies.get("token");
    try {
      const [ordenesPaquetesResponse, ordenesResponse] = await Promise.all([
        fetch(`${API_HOST}/ordenPaquetes`, {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }),
        fetch(`${API_HOST}/ordenes`, {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }),
      ]);

      const ordenesPaquetes = await ordenesPaquetesResponse.json();
      const ordenes = await ordenesResponse.json();

      console.table(ordenesPaquetes);
      const ordenesConTotales = ordenesPaquetes
        .map((op) => {
          const ordenesRelacionadas = ordenes.filter(
            (o) => o.numeroOrden === op.numeroOrden
          );
          const subtotal = ordenesRelacionadas.reduce(
            (sum, o) => sum + parseFloat(o.subtotal || 0),
            0
          );
          const descuento = ordenesRelacionadas.reduce(
            (sum, o) => sum + parseFloat(o.descuento || 0),
            0
          );
          const isv = ordenesRelacionadas.reduce(
            (sum, o) => sum + parseFloat(o.isv || 0),
            0
          );
          const total = ordenesRelacionadas.reduce(
            (sum, o) => sum + parseFloat(o.total || 0),
            0
          );

          return {
            ...op,
            subtotal,
            descuento,
            totalISV: isv,
            total,
          };
        })
        .filter(
          (op) =>
            op.estado === "No Pagado" || op.estado === "Entregado - No Pagado"
        );

      setOrdenesPaquetesList(ordenesConTotales);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const fetchInformacionSar = async () => {
    try {
      const bearertoken = cookies.get("token");
      const response = await fetch(`${API_HOST}/informacion-sar`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
      });
      const result = await response.json();
      setInformacionSarList(result);
    } catch (error) {
      console.error("Error fetching información SAR:", error);
    }
  };

  const fetchRtns = async () => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/rtns`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
      });
      const result = await response.json();
      setRtnsList(result);
    } catch (error) {
      console.error("Error fetching RTNs:", error);
    }
  };

  const fetchRtnFactura = async (idFactura) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(
        `${API_HOST}/facturas/rtnFactura/${idFactura}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }
      );
      const result = await response.json();
      console.log(result);
      return result;
    } catch (error) {
      console.error("Error fetching RTN Factura:", error);
      return null;
    }
  };

  const filterData = () => {
    const filtered = data.filter(
      (factura) =>
        factura.correlativo
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (factura.nombreCliente &&
          factura.nombreCliente
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        factura.estado.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (factura.ordenPaquete?.numeroOrden &&
          factura.ordenPaquete.numeroOrden
            .toString()
            .includes(searchTerm.toLowerCase()))
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const filterRtns = () => {
    return rtnsList.filter(
      (rtn) =>
        rtn.rtn.toLowerCase().includes(rtnSearchTerm.toLowerCase()) ||
        (rtn.nombre &&
          rtn.nombre.toLowerCase().includes(rtnSearchTerm.toLowerCase()))
    );
  };

  const formatCorrelativo = (factura) => {
    if (!factura.informacionSar || !factura.correlativo)
      return factura.correlativo || "";

    const correlativoFactura = factura.correlativo.toString();
    const cerosNecesarios = 8 - correlativoFactura.length;
    const ceros = cerosNecesarios > 0 ? "0".repeat(cerosNecesarios) : "";

    return `${factura.informacionSar.correlativo}-${ceros}${correlativoFactura}`;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.idInformacionSar) {
      newErrors.idInformacionSar = "La información SAR es requerida";
    } else {
      const selectedSar = informacionSarList.find(
        (sar) => sar.idInformacionSar === Number(formData.idInformacionSar)
      );

      if (selectedSar) {
        if (formData.correlativo > selectedSar.rangoFinal) {
          newErrors.correlativo = `El correlativo no puede ser mayor que ${selectedSar.rangoFinal}`;
        }

        if (formData.correlativo < selectedSar.rangoInicial) {
          newErrors.correlativo = `El correlativo no puede ser menor que ${selectedSar.rangoInicial}`;
        }
      }
    }

    if (!formData.idOrdenesPaquetes) {
      newErrors.idOrdenesPaquetes = "La orden de paquete es requerida";
    }

    if (formData.tipoCliente === "Otro") {
      if (!formData.nombreCliente) {
        newErrors.nombreCliente = "El nombre del cliente es requerido";
      }
      if (!formData.rtnCliente) {
        newErrors.rtnCliente = "El RTN es requerido";
      } else if (formData.rtnCliente.length !== 14) {
        newErrors.rtnCliente = "El RTN debe tener 14 caracteres";
      }
    }

    if (!formData.metodoPago || !metodosPago.includes(formData.metodoPago)) {
      newErrors.metodoPago = "Seleccione un método de pago válido";
    }

    if (formData.metodoPago !== "Efectivo" && !formData.comprobantePago) {
      newErrors.comprobantePago =
        "El comprobante es requerido para este método de pago";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = async (factura) => {
    setSelectedItem(factura);

    if (factura.tipoCliente === "Otro") {
      try {
        const rtnFacturaData = await fetchRtnFactura(factura.idFactura);
        if (rtnFacturaData && rtnFacturaData.rtn) {
          setRtnFacturaInfo({
            nombreCliente: rtnFacturaData.rtn.nombre || "",
            rtnCliente: rtnFacturaData.rtn.rtn,
          });
        } else {
          setRtnFacturaInfo({
            nombreCliente: factura.nombreCliente || "",
            rtnCliente: factura.rtnCliente || "",
          });
        }
      } catch (error) {
        console.error("Error al obtener RTN de factura:", error);
        setRtnFacturaInfo({
          nombreCliente: factura.nombreCliente || "",
          rtnCliente: factura.rtnCliente || "",
        });
      }
    } else {
      setRtnFacturaInfo(null);
    }

    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setRtnFacturaInfo(null);
  };

  const handleShowModal = async (factura = null) => {
    await fetchInformacionSar();

    let initialSarId = "";
    let initialCorrelativo = "";

    if (!factura) {
      if (data.length > 0) {
        const lastFactura = data[0]; 
        const currentSar = lastFactura.informacionSar;

        if (lastFactura.correlativo < currentSar.rangoFinal) {
          initialSarId = currentSar.idInformacionSar;
          initialCorrelativo = lastFactura.correlativo + 1;
        } else {
          const nextSar = informacionSarList.find(
            (sar) => sar.rangoInicial > currentSar.rangoFinal
          );

          if (nextSar) {
            initialSarId = nextSar.idInformacionSar;
            initialCorrelativo = nextSar.rangoInicial;
          } else {
            Swal.fire(
              "Advertencia",
              "No hay rangos SAR disponibles para generar nuevas facturas",
              "warning"
            );
            return;
          }
        }
      } else {
        if (informacionSarList.length > 0) {
          initialSarId = informacionSarList[0].idInformacionSar;
          initialCorrelativo = 2507;
        }
      }
    }

    if (factura) {
      const formattedItem = {
        ...factura,
        fechaEmision: factura.fechaEmision
          ? factura.fechaEmision.split("T")[0]
          : new Date().toLocaleDateString("en-CA", {
              timeZone: "America/Tegucigalpa",
            }),
        idOrdenesPaquetes: factura.ordenPaquete?.idOrdenesPaquetes || "",
      };

      const {
        idFactura,
        created_at,
        updated_at,
        informacionSar,
        ordenPaquete,
        usuario,
        ...filteredItem
      } = formattedItem;
      setFormData(filteredItem);
      setEditingId(factura.idFactura);
    } else {
      setFormData({
        idInformacionSar: initialSarId,
        correlativo: initialCorrelativo,
        idOrdenesPaquetes: "",
        tipoCliente: "Consumidor Final",
        nombreCliente: "",
        rtnCliente: "",
        metodoPago: "Efectivo",
        comprobantePago: "",
        fechaEmision: new Date().toLocaleDateString("en-CA", {
          timeZone: "America/Tegucigalpa",
        }),
        estado: "Activa",
        idUsuario: id_Usuario,
      });
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "tipoCliente" && value === "Consumidor Final") {
      setFormData((prev) => ({
        ...prev,
        nombreCliente: "",
        rtnCliente: "",
      }));
    }

    if (name === "metodoPago" && value === "Efectivo") {
      setFormData((prev) => ({ ...prev, comprobantePago: "" }));
    }

    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };

  const handleSelectRtn = (rtn) => {
    setFormData((prev) => ({
      ...prev,
      rtnCliente: rtn.rtn,
      nombreCliente: rtn.nombre || "",
    }));
    setShowRtnModal(false);
  };

  const updateOrderStatus = async (orderId) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/ordenPaquetes/${orderId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
        body: JSON.stringify({
          estado: "Facturado",
        }),
      });

      if (!response.ok) {
        throw new Error("Error al actualizar el estado de la orden");
      }

      return true;
    } catch (error) {
      console.error("Error updating order status:", error);
      return false;
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor corrija los errores en el formulario",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/facturas/${editingId}` : "/facturas";

    const dataToSubmit = {
      ...formData,
      idInformacionSar: Number(formData.idInformacionSar),
      idOrdenesPaquetes: Number(formData.idOrdenesPaquetes),
      idUsuario: Number(formData.idUsuario),
    };

    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }

      const result = await response.json();

      if (!editingId && dataToSubmit.idOrdenesPaquetes) {
        const updateSuccess = await updateOrderStatus(
          dataToSubmit.idOrdenesPaquetes
        );
        if (!updateSuccess) {
          Swal.fire(
            "Advertencia",
            "Factura creada pero no se pudo actualizar el estado de la orden",
            "warning"
          );
        }
      }

      Swal.fire({
        title: "Éxito",
        text: editingId
          ? "Factura actualizada correctamente"
          : "Factura creada correctamente",
        icon: "success",
        showCancelButton: !editingId,
        confirmButtonText: "OK",
        cancelButtonText: "Imprimir Factura",
      }).then((swalResult) => {
        if (swalResult.isDismissed && !editingId) {
          navigate(`/imprimirFactura/${result.idFactura || result.insertId}`);
        }
      });

      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "Hubo un problema en la operación",
        "error"
      );
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/facturas/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: API,
            },
          });
          Swal.fire("Eliminada!", "La factura ha sido eliminada.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar la factura", "error");
        }
      }
    });
  };

  const handlePrint = (idFactura) => {
    navigate(`/imprimirFactura/${idFactura}`);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const formatDate = (dateString) => {
    if (!dateString || new Date(dateString).getTime() === 0) {
      return "No disponible";
    }

    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("en-CA", options);
  };

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case "Activa":
        return <Badge bg='success'>{estado}</Badge>;
      case "Anulada":
        return <Badge bg='danger'>{estado}</Badge>;
      case "Pendiente":
        return (
          <Badge bg='warning' text='dark'>
            {estado}
          </Badge>
        );
      default:
        return <Badge bg='secondary'>{estado}</Badge>;
    }
  };

  const updateFacturaStatus = async (idFactura, nuevoEstado) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/facturas/${idFactura}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: API,
        },
        body: JSON.stringify({
          estado: nuevoEstado,
        }),
      });

      if (!response.ok) {
        throw new Error("Error al actualizar el estado de la factura");
      }

      return true;
    } catch (error) {
      console.error("Error updating invoice status:", error);
      return false;
    }
  };

  const handleStatusChange = async (factura) => {
    const nuevoEstado = factura.estado === "Activa" ? "Anulada" : "Activa";

    Swal.fire({
      title: `¿Cambiar estado a ${nuevoEstado}?`,
      text: `Estás a punto de cambiar el estado de la factura ${formatCorrelativo(
        factura
      )} a ${nuevoEstado}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const success = await updateFacturaStatus(
          factura.idFactura,
          nuevoEstado
        );

        if (success) {
          Swal.fire(
            "Estado actualizado!",
            `El estado de la factura ha sido cambiado a ${nuevoEstado}.`,
            "success"
          );
          fetchData(); 
        } else {
          Swal.fire(
            "Error",
            "No se pudo cambiar el estado de la factura",
            "error"
          );
        }
      }
    });
  };

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => ({
      ID: item.idFactura,
      Correlativo: formatCorrelativo(item),
      "Tipo Cliente": item.tipoCliente,
      "Nombre Cliente":
        item.tipoCliente === "Consumidor Final"
          ? "Consumidor Final"
          : item.nombreCliente || "N/A",
      RTN:
        item.tipoCliente === "Consumidor Final"
          ? "N/A"
          : item.rtnCliente || "N/A",
      "Orden #": item.ordenPaquete?.numeroOrden || "N/A",
      "Subtotal (L)": item.ordenPaquete?.subtotal?.toFixed(2) || "0.00",
      "ISV (L)": item.ordenPaquete?.totalISV?.toFixed(2) || "0.00",
      "Descuento (L)": item.ordenPaquete?.descuento?.toFixed(2) || "0.00",
      "Total (L)": item.ordenPaquete?.total?.toFixed(2) || "0.00",
      "Método Pago": item.metodoPago,
      Comprobante: item.comprobantePago || "N/A",
      Estado: item.estado,
      "Fecha Emisión": formatDate(item.fechaEmision),
      "CAI SAR": item.informacionSar?.cai || "N/A",
      "Rango SAR": item.informacionSar
        ? `${item.informacionSar.rangoInicial}-${item.informacionSar.rangoFinal}`
        : "N/A",
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Facturas");


    const colWidths = [
      { wch: 8 }, 
      { wch: 15 }, 
      { wch: 15 }, 
      { wch: 25 }, 
      { wch: 15 }, 
      { wch: 10 }, 
      { wch: 12 }, 
      { wch: 10 }, 
      { wch: 12 }, 
      { wch: 12 }, 
      { wch: 15 }, 
      { wch: 20 }, 
      { wch: 12 }, 
      { wch: 15 }, 
      { wch: 25 }, 
      { wch: 15 },
    ];
    worksheet["!cols"] = colWidths;

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2c3e50" } },
      alignment: { horizontal: "center" },
      border: {
        top: { style: "thin", color: { rgb: "1a1a1a" } },
        bottom: { style: "thin", color: { rgb: "1a1a1a" } },
        left: { style: "thin", color: { rgb: "1a1a1a" } },
        right: { style: "thin", color: { rgb: "1a1a1a" } },
      },
    };

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });

      if (!worksheet[headerCell].s) worksheet[headerCell].s = {};
      Object.assign(worksheet[headerCell].s, headerStyle);

      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        const cell = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cell]) continue;
        if (!worksheet[cell].s) worksheet[cell].s = {};
        worksheet[cell].s.border = {
          top: { style: "thin", color: { rgb: "e0e0e0" } },
          bottom: { style: "thin", color: { rgb: "e0e0e0" } },
          left: { style: "thin", color: { rgb: "e0e0e0" } },
          right: { style: "thin", color: { rgb: "e0e0e0" } },
        };

        if ([0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 12, 14, 15].includes(C)) {
          worksheet[cell].s.alignment = { horizontal: "center" };
        }
      }
    }

    const title = "Listado de Facturas";
    const company = "MBOX";
    const date = new Date().toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const infoSheet = XLSX.utils.aoa_to_sheet([
      [title],
      [""],
      [`Empresa: ${company}`],
      [`Fecha de exportación: ${date}`],
      [`Total facturas: ${filteredData.length}`],
      [
        `Facturas activas: ${
          filteredData.filter((f) => f.estado === "Activa").length
        }`,
      ],
      [
        `Facturas anuladas: ${
          filteredData.filter((f) => f.estado === "Anulada").length
        }`,
      ],
      [""],
    ]);

    infoSheet["A1"].s = { font: { bold: true, size: 16 } };
    infoSheet["A3"].s = { font: { italic: true } };
    infoSheet["A4"].s = { font: { italic: true } };
    infoSheet["A5"].s = { font: { bold: true } };
    infoSheet["A6"].s = { font: { bold: true } };
    infoSheet["A7"].s = { font: { bold: true } };

    XLSX.utils.book_append_sheet(workbook, infoSheet, "Informe");

    XLSX.writeFile(
      workbook,
      `Facturas_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const exportToPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
    });

    doc.setFontSize(18);
    doc.text("Listado de Facturas", 14, 15);
  
    doc.setFontSize(10);
    doc.text(`Exportado: ${new Date().toLocaleString()}`, 14, 22);

    doc.setFontSize(10);
    doc.text(
      `Total facturas: ${filteredData.length}`,
      doc.internal.pageSize.width - 60,
      22
    );

    autoTable(doc, {
      head: [
        [
          "Correlativo",
          "Cliente",
          "Orden #",
          "Total (L)",
          "Estado",
          "Fecha Emisión",
        ],
      ],
      body: filteredData.map((item) => [
        formatCorrelativo(item),
        item.tipoCliente === "Consumidor Final"
          ? "Consumidor Final"
          : item.nombreCliente || "N/A",
        item.ordenPaquete?.numeroOrden || "N/A",
        item.ordenPaquete?.total?.toFixed(2) || "0.00",
        item.estado,
        formatDate(item.fechaEmision),
      ]),
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      tableWidth: "auto", 
      margin: { left: 10, right: 10, top: 25 },
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(
        `Página ${i} de ${pageCount}`,
        doc.internal.pageSize.width - 25,
        doc.internal.pageSize.height - 5
      );
    }

    doc.save("facturas.pdf");
  };
  
  const downloadPDF = async (idFactura) => {
    const bearertoken = cookies.get("token");
  
    const getBase64FromImage = async (image) => {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      });
    };
  
    const img = new Image();
    img.src = logoImage;
    const logoBase64 = await getBase64FromImage(img);
  
    try {
      const response = await fetch(
        `${API_HOST}/facturas/imprimirFactura/${idFactura}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }
      );
  
      if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`);
  
      const factura = await response.json();
      const { factura: facturaData, informacionSar, ordenPaquete, rtnInfo } = factura;
      const { cai, rtn: rtnSar, correlativo: correlativoSar, rangoInicial, rangoFinal, fechaLimiteEmision } = informacionSar;
      const { fechaEmision, correlativo, metodoPago, comprobantePago, tipoCliente } = facturaData;
      const { cliente, ordenes } = ordenPaquete;
  
      const subtotal = ordenes.reduce((acc, orden) => acc + parseFloat(orden.subtotal), 0);
      const isv = ordenes.reduce((acc, orden) => acc + parseFloat(orden.isv), 0);
      const descuento = ordenes.reduce((acc, orden) => acc + parseFloat(orden.descuento), 0);
      const total = ordenes.reduce((acc, orden) => acc + parseFloat(orden.total), 0);
  
      const doc = new jsPDF({
        unit: "mm",
        format: [100, 297],
      });
  
      const marginLeft = 5;
      const marginRight = 5;
      const pageWidth = 100 - marginLeft - marginRight;
      let yPos = 10;
  
      doc.setFont("helvetica", "normal");
      doc.setTextColor(51, 51, 51); // #333333
  
      doc.setFontSize(24); 
      doc.setFont("helvetica", "bold");
      doc.text("MBOX S. De R.L", marginLeft + pageWidth / 2, yPos, { align: "center" });
      yPos += 4;
  
      if (logoBase64) {
        try {
          const logoWidth = 30; 
          const logoHeight = 30; 
    
          doc.addImage(logoBase64, 'PNG', marginLeft + pageWidth / 2 - logoWidth / 2, yPos, logoWidth, logoHeight);
          yPos += 35;
        } catch (e) {
          console.error("Error al insertar logo:", e);
          yPos += 10;
        }
      } else {
        yPos += 10;
      }
      
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(`FACTURA #${correlativoSar}-${String(correlativo).padStart(8, "0")}`, marginLeft, yPos);
      yPos += 6;
      doc.setDrawColor(51, 51, 51);
      doc.setLineWidth(0.3);
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 4;
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
    const infoFactura = [
  `Fecha: ${fechaEmision.slice(0, 10)}`,
  `Concepto: Traslado de paquete`,
  `CAI: ${cai}`,
  `RTN: ${rtnSar}`,
  `Rango: ${correlativoSar}-${String(rangoInicial).padStart(8, "0")} / ${correlativoSar}-${String(rangoFinal).padStart(8, "0")}`,
  `Válido hasta: ${fechaLimiteEmision.slice(0, 10)}`,
];

const maxWidth = pageWidth - marginLeft;

infoFactura.forEach(info => {

  if (info.startsWith('Rango:')) {
    const lines = doc.splitTextToSize(info, maxWidth);
    lines.forEach(line => {
      doc.text(line, marginLeft, yPos);
      yPos += 5.5; 
    });
  } else {
    doc.text(info, marginLeft, yPos);
    yPos += 5.5;
  }
});

      
  
      yPos += 6;
  
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("DATOS DEL CLIENTE", marginLeft, yPos);
      yPos += 5;
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 5;
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      const clienteData = [
        `Nombre: ${cliente.nombre}`,
        `Identidad: ${cliente.identidad}`,
        `Teléfono: ${cliente.telefono}`,
        `Cliente: ${tipoCliente}`,
        ...(rtnInfo?.rtn?.nombre ? [`Nombre: ${rtnInfo.rtn.nombre}`] : []),
        ...(rtnInfo?.rtn?.rtn ? [`RTN: ${rtnInfo.rtn.rtn}`] : []),
      ];
      clienteData.forEach(detail => {
        doc.text(detail, marginLeft, yPos);
        yPos += 5.5;
      });
  
      yPos += 5;
  
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("DETALLES DE PAQUETES", marginLeft, yPos);
      yPos += 5;
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 7;
  
      const columnConfig = [
        { x: marginLeft, width: 30, align: "left" },
        { x: marginLeft + 30, width: 40, align: "left" },
        { x: marginLeft + 60, width: 30, align: "right" },
      ];
  
      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.text("Tracking", columnConfig[0].x, yPos, { align: columnConfig[0].align });
      doc.text("Tipo", columnConfig[1].x, yPos, { align: columnConfig[1].align });
      doc.text("Peso", columnConfig[2].x, yPos, { align: columnConfig[2].align });

      yPos += 4;
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 6;
  
      doc.setFont("helvetica", "normal");
      ordenes.forEach(orden => {
        const tracking = orden.paquete.tracking.length > 12
          ? `${orden.paquete.tracking.substring(0, 6)}...${orden.paquete.tracking.slice(-6)}`
          : orden.paquete.tracking;
  
        doc.text(tracking, columnConfig[0].x, yPos, { align: columnConfig[0].align });
        doc.text(orden.paquete.tipoEnvio, columnConfig[1].x, yPos, { align: columnConfig[1].align });
        doc.text(`${orden.paquete.pesoMbox} lbs`, columnConfig[2].x, yPos, { align: columnConfig[2].align });
        doc.text(`L. ${parseFloat(orden.total).toFixed(2)}`, columnConfig[3].x, yPos, { align: columnConfig[3].align });
  
        yPos += 5;
      });
  
      yPos += 4;
  
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
  
      doc.setDrawColor(51, 51, 51); // Color de la línea
      doc.setLineWidth(0.3); // Ancho de la línea
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 5;
  
      const totals = [
        { label: "Subtotal:", value: subtotal.toFixed(2) },
        { label: "Descuento:", value: descuento.toFixed(2) },
        { label: "ISV (15%):", value: isv.toFixed(2) }
      ];
  
      totals.forEach(item => {
        doc.text(item.label, marginLeft, yPos, { align: "left" });
  
        doc.text(`L. ${item.value}`, marginLeft + pageWidth, yPos, { align: "right" });
  
        yPos += 5;
      });
  
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 5;
  
      doc.setFont("helvetica", "bold");
      doc.text("TOTAL:", marginLeft, yPos, { align: "left" });
      doc.text(`L. ${total.toFixed(2)}`, marginLeft + pageWidth, yPos, { align: "right" });
  
      yPos += 10;
  
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("MÉTODO DE PAGO", marginLeft, yPos);
      yPos += 5;
      doc.line(marginLeft, yPos, marginLeft + pageWidth, yPos);
      yPos += 5;
  
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.text(`Método: ${metodoPago}`, marginLeft, yPos);
      yPos += 5;
      if (comprobantePago) {
        doc.text(`Comprobante: ${comprobantePago}`, marginLeft, yPos);
        yPos += 5;
      }
  
      yPos += 8;
  
      doc.setFontSize(8);
      doc.setTextColor(85, 85, 85);
      doc.text(
        "Esta factura es un comprobante fiscal | Original: Cliente - Copia: Emisor",
        marginLeft + pageWidth / 2, yPos, { align: "center" }
      );
      yPos += 4;
      doc.text(
        "Bulevar Centro América, Edificio Corporativo C.A 5 Piso 3",
        marginLeft + pageWidth / 2, yPos, { align: "center" }
      );
      yPos += 4;
      doc.text(
        "Tegucigalpa, Honduras | Tel: 2230-0800",
        marginLeft + pageWidth / 2, yPos, { align: "center" }
      );
  
      yPos += 8;
  
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(51, 51, 51);
      doc.text("¡Gracias por su preferencia!", marginLeft + pageWidth / 2, yPos, { align: "center" });
  
      doc.save(`factura_${correlativoSar}-${String(correlativo).padStart(8, "0")}.pdf`);
  
    } catch (err) {
      console.error("Error al generar PDF:", err);
      alert("Error al generar el PDF: " + err.message);
    }
  };
  
  
  
  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Facturas</h5>
            <div>
              <Dropdown className='d-inline me-2'>
                <Dropdown.Toggle variant='outline-primary' size='sm'>
                  <FiDownload className='me-1' /> Exportar
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={exportToExcel}>
                    <FiFileText className='me-2' /> Excel (.xlsx)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportToPDF}>
                    <FiFile className='me-2' /> PDF (.pdf)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant='success'
                onClick={() => handleShowModal()}
                size='sm'
              >
                Agregar Nuevo
              </Button>
            </div>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por correlativo, cliente o estado...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>ID</th>
                  <th className='border-top-0'>Correlativo</th>
                  <th className='border-top-0'>Cliente</th>
                  <th className='border-top-0'>Orden #</th>
                  <th className='border-top-0'>Total</th>
                  <th className='border-top-0'>Estado</th>
                  <th className='border-top-0'>Fecha</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((factura) => (
                  <tr key={factura.idFactura}>
                    <td className='text-muted'>{factura.idFactura}</td>
                    <td>{formatCorrelativo(factura)}</td>
                    <td>
                      {factura.tipoCliente === "Consumidor Final"
                        ? "Consumidor Final"
                        : rtnFacturaInfo?.nombreCliente ||
                          factura.nombreCliente ||
                          "Otro"}
                    </td>
                    <td>#{factura.ordenPaquete?.numeroOrden || "N/A"}</td>
                    <td>
                      L. {factura.ordenPaquete?.total?.toFixed(2) || "0.00"}
                    </td>
                    <td
                      onClick={() => handleStatusChange(factura)}
                      style={{ cursor: "pointer" }}
                    >
                      {getEstadoBadge(factura.estado)}
                    </td>
                    <td>{formatDate(factura.fechaEmision)}</td>
                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(factura)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(factura)}
                        className='me-2'
                        title='Ver detalles'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                      <Button
                        variant='outline-danger' // Rojo para diferenciarlo del botón de imprimir
                        onClick={() => downloadPDF(factura.idFactura)}
                        className="me-2"
                        title='Descargar PDF'
                        size='sm'
                      >
                        <FiDownload />{" "}
                        {/* Icono de descarga (asegúrate de importarlo) */}
                      </Button>
                      <Button
                        variant='outline-secondary'
                        onClick={() => handlePrint(factura.idFactura)}
                        title='Imprimir'
                        size='sm'
                      >
                        <FiPrinter />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {filteredData.length}{" "}
              registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      {/* Modal para agregar/editar */}
      <Modal show={showModal} onHide={handleCloseModal} centered size='lg'>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>{editingId ? "Editar" : "Nueva"} Factura</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Información SAR
                  </Form.Label>
                  <Form.Control
                    as='select'
                    name='idInformacionSar'
                    value={formData.idInformacionSar}
                    onChange={handleChange}
                    isInvalid={!!errors.idInformacionSar}
                    className='border'
                    disabled={!editingId}
                  >
                    <option value=''>Seleccionar SAR</option>
                    {informacionSarList.map((sar) => (
                      <option
                        key={sar.idInformacionSar}
                        value={sar.idInformacionSar}
                      >
                        {sar.correlativo} (Rango: {sar.rangoInicial}-
                        {sar.rangoFinal})
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type='invalid'>
                    {errors.idInformacionSar}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Prefactura
                  </Form.Label>
                  <Form.Control
                    list='prefacturasList'
                    name='prefacturaInput'
                    value={selectedPrefacturaLabel}
                    onChange={handlePrefacturaChange}
                    isInvalid={!!errors.idOrdenesPaquetes}
                    className='border'
                    placeholder='Buscar por nombre de cliente o número de orden'
                  />
                  <datalist id='prefacturasList'>
                    {ordenesPaquetesList.map((orden) => (
                      <option
                        key={orden.idOrdenesPaquetes}
                        value={`Orden #${orden.numeroOrden} - ${
                          orden.cliente?.nombre || "Sin cliente"
                        } (Total: L. ${orden.total?.toFixed(2) || "0.00"})`}
                        data-id={orden.idOrdenesPaquetes}
                      />
                    ))}
                  </datalist>
                  <Form.Control
                    type='hidden'
                    name='idOrdenesPaquetes'
                    value={formData.idOrdenesPaquetes}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.idOrdenesPaquetes}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>{" "}
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Correlativo</Form.Label>
                  <Form.Control
                    type='text'
                    name='correlativo'
                    value={formData.correlativo}
                    readOnly
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.correlativo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Tipo de Cliente
                  </Form.Label>
                  <Form.Control
                    as='select'
                    name='tipoCliente'
                    value={formData.tipoCliente}
                    onChange={handleChange}
                    isInvalid={!!errors.tipoCliente}
                    className='border'
                  >
                    {tiposCliente.map((tipo) => (
                      <option key={tipo} value={tipo}>
                        {tipo}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Método de Pago
                  </Form.Label>
                  <Form.Control
                    as='select'
                    name='metodoPago'
                    value={formData.metodoPago}
                    onChange={handleChange}
                    isInvalid={!!errors.metodoPago}
                    className='border'
                  >
                    {metodosPago.map((metodo) => (
                      <option key={metodo} value={metodo}>
                        {metodo}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type='invalid'>
                    {errors.metodoPago}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            {formData.tipoCliente === "Otro" && (
              <>
                <Row>
                  <Col md={6}>
                    <Form.Group className='mb-3'>
                      <Form.Label>
                        <span className='text-danger'>*</span> Nombre del
                        Cliente
                      </Form.Label>
                      <Form.Control
                        type='text'
                        name='nombreCliente'
                        value={formData.nombreCliente}
                        onChange={handleChange}
                        isInvalid={!!errors.nombreCliente}
                        className='border'
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.nombreCliente}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className='mb-3'>
                      <Form.Label>
                        <span className='text-danger'>*</span> RTN del Cliente
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          type='text'
                          name='rtnCliente'
                          value={formData.rtnCliente}
                          onChange={handleChange}
                          isInvalid={!!errors.rtnCliente}
                          className='border'
                        />
                        <Button
                          variant='outline-secondary'
                          onClick={() => setShowRtnModal(true)}
                          title='Buscar RTN'
                        >
                          <FiSearch />
                        </Button>
                        <Form.Control.Feedback type='invalid'>
                          {errors.rtnCliente}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            {formData.metodoPago !== "Efectivo" && (
              <Row>
                <Col md={12}>
                  <Form.Group className='mb-3'>
                    <Form.Label>
                      <span className='text-danger'>*</span> Comprobante de Pago
                    </Form.Label>
                    <Form.Control
                      type='text'
                      name='comprobantePago'
                      value={formData.comprobantePago}
                      onChange={handleChange}
                      isInvalid={!!errors.comprobantePago}
                      className='border'
                    />
                    <Form.Control.Feedback type='invalid'>
                      {errors.comprobantePago}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            )}

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Fecha de Emisión</Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaEmision'
                    value={formData.fechaEmision}
                    onChange={handleChange}
                    disabled
                    className='border'
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
          {formData.idOrdenesPaquetes && (
            <Row className='mt-4'>
              <Col md={12}>
                <div className='border p-3 bg-light rounded'>
                  <h6 className='fw-bold'>Resumen de Factura</h6>
                  <Row>
                    <Col md={4}>
                      <p className='mb-1'>Subtotal:</p>
                      <h5>L. {(total /1.15).toFixed(2)}</h5>
                    </Col>
                    <Col md={4}>
                      <p className='mb-1'>ISV (15%):</p>
                      <h5>L. {(total - total/1.15).toFixed(2)}</h5>
                    </Col>
                    <Col md={4}>
                      <p className='mb-1'>Total:</p>
                      <h5 className='text-primary'>
                        L. {total?.toFixed(2) || "0.00"}
                      </h5>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        centered
        size='lg'
      >
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles de Factura #{selectedItem?.idFactura}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-4'>
                <h6 className='text-muted mb-3'>Información Básica</h6>
                <Row>
                  <Col md={4}>
                    <p className='mb-2'>
                      <span className='fw-medium'>ID Factura:</span>{" "}
                      {selectedItem.idFactura}
                    </p>
                    <p className='mb-2'>
                      <span className='fw-medium'>Correlativo:</span>{" "}
                      {formatCorrelativo(selectedItem)}
                    </p>
                    <p className='mb-2'>
                      <span className='fw-medium'>Estado:</span>{" "}
                      {getEstadoBadge(selectedItem.estado)}
                    </p>
                  </Col>
                  <Col md={4}>
                    <p className='mb-2'>
                      <span className='fw-medium'>Tipo Cliente:</span>{" "}
                      {selectedItem.tipoCliente}
                    </p>
                    {selectedItem.tipoCliente === "Otro" && (
                      <>
                        <p className='mb-2'>
                          <span className='fw-medium'>Nombre:</span>{" "}
                          {rtnFacturaInfo?.nombreCliente ||
                            selectedItem.nombreCliente ||
                            "N/A"}
                        </p>
                        <p className='mb-2'>
                          <span className='fw-medium'>RTN:</span>{" "}
                          {rtnFacturaInfo?.rtnCliente ||
                            selectedItem.rtnCliente ||
                            "N/A"}
                        </p>
                      </>
                    )}
                    <p className='mb-2'>
                      <span className='fw-medium'>Método Pago:</span>{" "}
                      {selectedItem.metodoPago}
                    </p>
                    {selectedItem.comprobantePago && (
                      <p className='mb-2'>
                        <span className='fw-medium'>Comprobante:</span>{" "}
                        {selectedItem.comprobantePago}
                      </p>
                    )}
                  </Col>
                  <Col md={4}>
                    <p className='mb-2'>
                      <span className='fw-medium'>Fecha Emisión:</span>{" "}
                      {formatDate(selectedItem.fechaEmision)}
                    </p>
                    <p className='mb-2'>
                      <span className='fw-medium'>Registrado por:</span>{" "}
                      {selectedItem.usuario?.nombre_Completo || "N/A"}
                    </p>
                  </Col>
                </Row>
              </div>

              <div className='mb-4'>
                <h6 className='text-muted mb-3'>Información de Pago</h6>
                <Row>
                  <Col md={4}>
                    <p className='mb-2'>
                      <span className='fw-medium'>Subtotal:</span> L.{" "}
                      {selectedItem.ordenPaquete?.subtotal?.toFixed(2) ||
                        "0.00"}
                    </p>
                    <p className='mb-2'>
                      <span className='fw-medium'>Descuento:</span> L.{" "}
                      {selectedItem.ordenPaquete?.descuento?.toFixed(2) ||
                        "0.00"}
                    </p>
                  </Col>
                  <Col md={4}>
                    <p className='mb-2'>
                      <span className='fw-medium'>ISV:</span> L.{" "}
                      {selectedItem.ordenPaquete?.totalISV?.toFixed(2) ||
                        "0.00"}
                    </p>
                    <p className='mb-2'>
                      <span className='fw-medium'>Total:</span> L.{" "}
                      {selectedItem.ordenPaquete?.total?.toFixed(2) || "0.00"}
                    </p>
                  </Col>
                </Row>
              </div>

              <div className='mb-4'>
                <h6 className='text-muted mb-3'>Relaciones</h6>
                <Row>
                  <Col md={6}>
                    <div className='card border-0 shadow-sm mb-3'>
                      <div className='card-body'>
                        <h6 className='card-title'>Información SAR</h6>
                        {selectedItem.informacionSar ? (
                          <div>
                            <p className='mb-1'>
                              <span className='fw-medium'>
                                Correlativo SAR:
                              </span>{" "}
                              {selectedItem.informacionSar.correlativo}
                            </p>
                            <p className='mb-1'>
                              <span className='fw-medium'>Rango:</span>{" "}
                              {selectedItem.informacionSar.rangoInicial} -{" "}
                              {selectedItem.informacionSar.rangoFinal}
                            </p>
                            <p className='mb-1'>
                              <span className='fw-medium'>CAI:</span>{" "}
                              {selectedItem.informacionSar.cai}
                            </p>
                            <p className='mb-0'>
                              <span className='fw-medium'>Fecha Límite:</span>{" "}
                              {formatDate(
                                selectedItem.informacionSar.fechaLimiteEmision
                              )}
                            </p>
                          </div>
                        ) : (
                          <p className='text-muted mb-0'>
                            No hay información SAR asociada
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className='card border-0 shadow-sm'>
                      <div className='card-body'>
                        <h6 className='card-title'>Orden de Paquete</h6>
                        {selectedItem.ordenPaquete ? (
                          <div>
                            <p className='mb-1'>
                              <span className='fw-medium'>ID Orden:</span> #
                              {selectedItem.ordenPaquete.numeroOrden}
                            </p>
                            <p className='mb-1'>
                              <span className='fw-medium'>Cliente:</span>{" "}
                              {selectedItem.ordenPaquete.cliente?.nombre ||
                                "N/A"}
                            </p>
                            <p className='mb-1'>
                              <span className='fw-medium'>Estado:</span>{" "}
                              {selectedItem.ordenPaquete.estado}
                            </p>
                          </div>
                        ) : (
                          <p className='text-muted mb-0'>
                            No hay orden de paquete asociada
                          </p>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
          <Button
            variant='primary'
            onClick={() => handlePrint(selectedItem.idFactura)}
          >
            <FiPrinter className='me-1' /> Imprimir Factura
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para buscar RTN */}
      <Modal show={showRtnModal} onHide={() => setShowRtnModal(false)} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>Buscar RTN</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-3'>
            <Form.Label>Buscar RTN o Nombre</Form.Label>
            <Form.Control
              type='text'
              placeholder='Ingrese RTN o nombre'
              value={rtnSearchTerm}
              onChange={(e) => setRtnSearchTerm(e.target.value)}
            />
          </Form.Group>

          <div
            className='table-responsive'
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            <Table hover>
              <thead>
                <tr>
                  <th>RTN</th>
                  <th>Nombre</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {filterRtns().map((rtn) => (
                  <tr key={rtn.idRtn}>
                    <td>{rtn.rtn}</td>
                    <td>{rtn.nombre || "N/A"}</td>
                    <td>
                      <Button
                        variant='outline-primary'
                        size='sm'
                        onClick={() => handleSelectRtn(rtn)}
                      >
                        Seleccionar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button
            variant='outline-secondary'
            onClick={() => setShowRtnModal(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Factura;
